import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getApiUrl, getNetwork } from "utils";
import { RootState, AppThunk } from "../../app/store";

export interface GeneralState {
  network: string;
}
const defaultNetwork = getNetwork().network;
const initialState: GeneralState = {
  network: defaultNetwork,
};

export const generalSlice = createSlice({
  name: "general",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    selectNetwork: (state, action: PayloadAction<string>) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.network = action.payload;
    },
  },
});
// Define a service using a base URL and expected endpoints
export const generalApi = createApi({
  reducerPath: "getTokenList",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://raw.githubusercontent.com/neonscan/token-list/main/",
  }),
  endpoints: (builder) => ({
    getTokenArg: builder.query<any, string>({
      query: (file) => `${file}`,
    }),
    // getTxsChart: builder.query<any, { type: string; from: number; to: number }>(
    //   {
    //     query: ({ type, from, to }) =>
    //       `overview/txs_chart?type=${type}&from=${from}&to=${to}`,
    //   }
    // ),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetTokenArgQuery } = generalApi;

export const { selectNetwork } = generalSlice.actions;

export const currentNetwork = (state: RootState) => state.general.network;

export default generalSlice.reducer;
